/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-08-26",
    versionChannel: "nightly",
    buildDate: "2023-08-26T00:22:29.980Z",
    commitHash: "b456296769e3232ca41e0da369c11e2181404733",
};
